// Module
var code = "<div class=\"modal {{class}}\" id=\"{{id}}\" tabindex=\"-1\" role=\"dialog\"> <div class=\"modal-dialog\" role=\"document\"> <div class=\"modal-content\"></div> </div> </div>";
// Exports
module.exports = code;